
import { get, post, remove,put } from "../api_helper";
import * as url from "../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getDeductiontypeDetails =(code)=> get(`${baseURL+url.DEDUCTIONTYPE_BASE}/${code}`);
export const getDeductiontypes =({page,pageSize})=> get(baseURL+url.DEDUCTIONTYPE_BASE+`?pageNumber=${page}&pageSize=${pageSize}`);
export const updateDeductiontype = (code, payload) => put(`${baseURL}${url.DEDUCTIONTYPE_BASE}/${code}`, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const createDeductiontype =(payload) => post(baseURL+url.DEDUCTIONTYPE_BASE,payload);

export const deleteDeductiontype = (code) => remove(`${baseURL}${url.DEDUCTIONTYPE_BASE}/${code}`);
export const getAllDeductiontypeDetails  = () => get(`${baseURL}${url.DEDUCTIONTYPE_BASE}`);
